// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1bq8W","title":"Images90_title__2WRFg","images":"Images90_images__21B5M"};